import { render, staticRenderFns } from "./edit-orderdispose.vue?vue&type=template&id=4e4288b4&"
import script from "./edit-orderdispose.vue?vue&type=script&lang=ts&"
export * from "./edit-orderdispose.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "edit-orderdispose.vue"
export default component.exports